export default __webpack_public_path__ + "static/media/ProfileActive.57530c2e.svg";